/* eslint-disable @typescript-eslint/naming-convention */

import { Children } from 'react';

import { useDetermineMobile } from '@myrealtrip/device-detect';

import styled from '@emotion/styled';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';

import LocalNavItem from './LocalNavItem';
import RestLocalNavItems from './RestLocalNavItems';

const MAX_DISPLAY_VERTICAL_LENGTH = 9;

export default function MainPageLocalNavItems() {
  const { mainVerticalItems, subVerticalItems } = useLayoutHeaderContext();
  const isMobile = useDetermineMobile();
  const filterdMainVerticalItems =
    mainVerticalItems?.filter(({ level, title }) => level === 1 && title) ?? [];
  const filterdSubVerticalItems = subVerticalItems?.filter(({ title }) => Boolean(title)) ?? [];

  const mergedVerticalItems = [...filterdMainVerticalItems, ...filterdSubVerticalItems];
  const displayVerticalItems = mergedVerticalItems.slice(0, MAX_DISPLAY_VERTICAL_LENGTH);

  const restVerticalItems = mergedVerticalItems
    .slice(displayVerticalItems.length)
    .map(({ link, title, cms_icon_url }) => ({
      link: link.desktop,
      label: title,
      iconUrl: cms_icon_url,
    }));

  return (
    <Container>
      {Children.toArray(
        displayVerticalItems?.map(({ title, code, cms_icon_url, badge, badge_style, link }) => (
          <LocalNavItem
            label={title}
            code={code}
            showIcon
            iconUrl={cms_icon_url}
            badge={{ badgeName: badge, badgeStyle: badge_style }}
            link={isMobile ? link.mobile_web : link.desktop}
          />
        )),
      )}
      {restVerticalItems?.length > 0 && (
        <RestLocalNavItems verticalItems={restVerticalItems} showIcon />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: space-between;
`;
